import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">图文推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">精选51大赛图文内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-200 flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={`51大赛 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <p className="text-xs text-foreground-400 mb-2">{item.date}</p>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug flex-1">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.description}</p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  <span>阅读全文</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}